/* conditionalDropdownData.js */

"use strict";

const CONDITIONAL_DATA = {
    string: {
        eq: { label: "Equals", fields: 1, type: "text" },
        neq: { label: "Not Equals", fields: 1, type: "text" },
        contains: { label: "Contains", fields: 1, type: "text" },
        ncontains: { label: "Doesn't contain", fields: 1, type: "text" },
        empty: { label: "Is Empty", fields: 0 },
        nempty: { label: "Is not empty", fields: 0 },
        nstarts: { label: "Doesn't start with", fields: 1, type: "text" },
        starts: { label: "Starts with", fields: 1, type: "text" },
        ends: { label: "Ends with", fields: 1, type: "text" },
        nends: { label: "Doesn't end with", fields: 1, type: "text" },
        match: { label: "Match", fields: 1, type: "text" },
        nmatch: { label: "Doesn't match", fields: 1, type: "text" }
    },
    enum: {
        eq: { label: "Equals", fields: 1, type: "dropdown" },
        neq: { label: "Not Equals", fields: 1, type: "dropdown" }
    },
    number: {
        eq: { label: "Equals", fields: 1, type: "number" },
        neq: { label: "Not Equals", fields: 1, type: "number" },
        gt: { label: "greater", fields: 1, type: "number" },
        gte: { label: "greater or equal", fields: 1, type: "number" },
        lt: { label: "less", fields: 1, type: "number" },
        lte: { label: "less or equal", fields: 1, type: "number" },
        range: { label: "between", fields: 2, type: "number" },
        nrange: { label: "not between", fields: 2, type: "number" }
    },
    unixTime: {
        eq: { label: "Equals", fields: 1, type: "date" },
        neq: { label: "Not Equals", fields: 1, type: "date" },
        gt: { label: "greater", fields: 1, type: "date" },
        gte: { label: "greater or equal", fields: 1, type: "date" },
        lt: { label: "less", fields: 1, type: "date" },
        lte: { label: "less or equal", fields: 1, type: "date" },
        range: { label: "between", fields: 2, type: "date" },
        nrange: { label: "not between", fields: 2, type: "date" }
    },
    boolean: {
        eq: { label: "Equals", fields: 2, type: "radio" }
    }
};

module.exports = {
    CONDITIONAL_DATA
};
